import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NameSectionForm from '../../../../../ReusableFormSections/NameSection/NameSectionForm'

import { clearUpdateCampaign, updateCampaign } from '../../../../../../modules/actions/campaigns'
import {
  campaignUpdateErrorSelector,
  campaignUpdateIsLoadingSelector,
  campaignWasUpdatedSelector
} from '../../../../../../modules/selectors/campaigns'
import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const NameSection = ({ editItemData: campaign, title, updateOptions, ...formProps }) => {
  const dispatch = useDispatch()

  const campaignWasUpdated = useSelector(campaignWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const handleSubmit = useCallback(
    values => {
      const updateCampaignData = {
        account: selectedAdAccountId,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        },
        ...values
      }

      dispatch(updateCampaign(updateCampaignData, campaign.id, DV_360_PLATFORM, updateOptions))
    },
    [dispatch, campaign.id, title, selectedAdAccountId, updateOptions]
  )

  const handleClearUpdateCampaign = useCallback(() => {
    dispatch(clearUpdateCampaign())
  }, [dispatch])

  return (
    <NameSectionForm
      placeholder="Campaign Name"
      editItem={campaign}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateCampaign}
      successSubmit={campaignWasUpdated}
      isLoadingSelector={campaignUpdateIsLoadingSelector}
      errorSelector={campaignUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default NameSection
